import React, { useEffect, useState } from "react";
import Sidebar from "../sidebar/sidebar";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { getList, updateData } from "../../hooks/api/utils";
import { JsonEditor, githubLightTheme } from "json-edit-react";

const EditVendorService = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, vendor_service } = location.state;

  const [vendors, setVendors] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);

  const [formData, setFormData] = useState({
    service: vendor_service?.service?.id || "",
    vendor: vendor_service?.vendor?.id || "",
    endpoint: vendor_service?.endpoint || "",
    service_code: vendor_service?.service_code || "",
    image_include: vendor_service?.image_include ?? false,
    method: vendor_service?.method || "POST",
    header_mapping: vendor_service?.header_mapping || {},
    parameter_mapping: vendor_service?.parameter_mapping || {},
    request_mapping: vendor_service?.request_mapping || {},
    response_mapping: vendor_service?.response_mapping || {},
    waiting_time: vendor_service?.waiting_time || null,
  });

  const [priceRanges, setPriceRanges] = useState(
    vendor_service?.price_ranges?.map((pr) => ({
      id: pr?.id || null,
      area_min: pr.area_min || "",
      area_max: pr.area_max || "",
      price_type: pr.price_type || "Tiered",
      price_per_ha: pr.price_per_ha || "",
      platform_fee_per_ha: pr.platform_fee_per_ha || "",
      image_min_ha: pr.image_min_ha || "",
      image_price_per_ha: pr.image_price_per_ha || "",
      image_fix_price: pr.image_fix_price || "",
      is_image: pr.image_price_per_ha || pr.image_fix_price ? true : false,
    })) || [
      {
        area_min: "",
        area_max: "",
        price_type: "Tiered",
        price_per_ha: "",
        platform_fee_per_ha: "",
        image_min_ha: "",
        image_price_per_ha: "",
        image_fix_price: "",
        is_image: false,
      },
    ]
  );

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getList("/admin-panel/active-vendors/", null, setVendors);
    getList("/admin-panel/services-list/", null, setFilteredServices);
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "image_include") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked,
      }));

      if (checked) {
        setPriceRanges((prev) =>
          prev.map((row) => ({
            ...row,
            is_image: true,
          }))
        );
      }
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors({});
  };

  const handleJsonChange = (name, jsonData) => {
    setFormData((prev) => ({ ...prev, [name]: jsonData }));
  };

  const handleRangeChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const newRanges = [...priceRanges];
    newRanges[index][name] = type === "checkbox" ? checked : value;
    setPriceRanges(newRanges);
  };

  const addNewRange = () => {
    setPriceRanges([
      ...priceRanges,
      {
        area_min: "",
        area_max: "",
        price_type: "Tiered",
        price_per_ha: "",
        platform_fee_per_ha: "",
        image_min_ha: "",
        image_price_per_ha: "",
        image_fix_price: "",
        is_image: false,
      },
    ]);
  };

  const removeRange = (index) => {
    if (priceRanges.length === 1) {
      alert("At least one row is required.");
      return;
    }
    setPriceRanges(priceRanges.filter((_, i) => i !== index));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.service) newErrors.service = "Service is required";
    if (!formData.vendor) newErrors.vendor = "Vendor is required";
    if (!formData.endpoint.trim()) newErrors.endpoint = "Endpoint is required";
    if (!formData.service_code.trim())
      newErrors.service_code = "Service code is required";

    if (priceRanges.length === 0) {
      newErrors.priceRanges = "At least one detail row is required";
    } else {
      priceRanges.forEach((range, idx) => {
        if (!range.area_min && range.area_min !== 0) {
          newErrors[`area_min_${idx}`] = "Min hectare is required";
        } else if (parseFloat(range.area_min) < 0) {
          newErrors[`area_min_${idx}`] = "Min hectare cannot be negative";
        }

     if (
  parseFloat(range.area_max) <= parseFloat(range.area_min)
) {
  newErrors[`area_max_${idx}`] =
    "Max hectare must be greater than Min hectare";
}

        if (!range.price_per_ha) {
          newErrors[`price_per_ha_${idx}`] =
            range.price_type === "fixed"
              ? "Price is required"
              : "Price per hectare is required";
        } 
        // else if (Number(range.price_per_ha) <= 0) {
        //   newErrors[`price_per_ha_${idx}`] =
        //     range.price_type === "fixed"
        //       ? "Price must be greater than 0"
        //       : "Price per hectare must be greater than 0";
        // }

        if (range.is_image) {
          if (!range.image_price_per_ha) {
            newErrors[`image_price_per_ha_${idx}`] =
              "Image Price per Hectare is required";
          }
          if (range.image_min_ha) {
            if (!range.image_fix_price) {
              newErrors[`image_fix_price_${idx}`] =
                "Image Fixed Price is required";
            }
          }
        }
      });
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    console.log('hello')
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = {
      service: formData.service,
      vendor: formData.vendor,
      endpoint: formData.endpoint,
      service_code: formData.service_code,
      method: formData.method,
      image_include: formData.image_include,
      header_mapping: formData.header_mapping,
      parameter_mapping: formData.parameter_mapping,
      waiting_time: formData.waiting_time,
      request_mapping: formData.request_mapping,
      response_mapping: formData.response_mapping,
      price_ranges: priceRanges.map((pr) => ({
        id: pr?.id ? pr?.id : null,
        area_min: parseFloat(pr.area_min),
        area_max: parseFloat(pr.area_max),
        price_type: pr.price_type,
        price_per_ha: parseFloat(pr.price_per_ha),
        platform_fee_per_ha: parseFloat(pr.platform_fee_per_ha) || 0,
        is_image: pr.is_image,
        image_min_ha:
          pr.is_image && pr.image_min_ha !== ""
            ? Number(pr.image_min_ha)
            : null,
        image_price_per_ha:
          pr.is_image && pr.image_price_per_ha !== ""
            ? parseFloat(pr.image_price_per_ha)
            : null,
        image_fix_price:
          pr.is_image && pr.image_fix_price !== ""
            ? parseFloat(pr.image_fix_price)
            : null,
      })),
    };

    setIsSubmitting(true);
    await updateData(
      `/admin-panel/vendor_services/`,
      id,
      setIsSubmitting,
      payload,
      navigate,
      "/vendor-services"
    );
  };

  return (
  
      <div className="rightContent">
        <div className="doc_info">
          <div className="row g-4">
            <div className="col-md-12">
              <div className="padding-inner border-radius-20 bg-white">
                <h4 className="mb-4">Edit Vendor Service</h4>
                <form onSubmit={handleSubmit}>
                  <div className="row g-4">
                    {/* Service */}
                    <div className="col-md-6">
                      <label>Service<span class= "text-danger">*</span></label>
                      <select
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                      >
                        <option value="">Select Service</option>
                        {filteredServices.map((s) => (
                          <option key={s.id} value={s.id}>
                            {s.name}
                          </option>
                        ))}
                      </select>
                      {errors.service && (
                        <div className="text-danger">{errors.service}</div>
                      )}
                    </div>

                    {/* Service Code */}
                    <div className="col-md-6">
                      <label>Service Code<span class= "text-danger">*</span></label>
                      <input
                        type="text"
                        name="service_code"
                        value={formData.service_code}
                        onChange={handleChange}
                        placeholder="Service code"
                      />
                      {errors.service_code && (
                        <div className="text-danger">{errors.service_code}</div>
                      )}
                    </div>

                    {/* Vendor */}
                    <div className="col-md-6">
                      <label>Vendor<span class= "text-danger">*</span></label>
                      <select
                        name="vendor"
                        value={formData.vendor}
                        onChange={handleChange}
                      >
                        <option value="">Select Vendor</option>
                        {vendors.map((v) => (
                          <option key={v.id} value={v.id}>
                            {v.first_name} {v.last_name}
                          </option>
                        ))}
                      </select>
                      {errors.vendor && (
                        <div className="text-danger">{errors.vendor}</div>
                      )}
                    </div>

                    {/* Endpoint */}
                    <div className="col-md-6">
                      <label>Endpoint<span class= "text-danger">*</span></label>
                      <input
                        type="text"
                        name="endpoint"
                        value={formData.endpoint}
                        onChange={handleChange}
                        placeholder="/api/endpoint"
                      />
                      {errors.endpoint && (
                        <div className="text-danger">{errors.endpoint}</div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label>Waiting Time</label>
                      <input
                        type="text"
                        name="waiting_time"
                        value={formData.waiting_time}
                        onChange={handleChange}
                        placeholder="1 min 20 sec"
                      />
                      {/* {errors.endpoint && (
                        <div className="text-danger">{errors.endpoint}</div>
                      )} */}
                    </div>

                    {/* Method */}
                    <div className="col-md-6">
                      <label>Method</label>
                      <select
                        name="method"
                        value={formData.method}
                        onChange={handleChange}
                      >
                        <option value="POST">POST</option>
                        <option value="GET">GET</option>
                      </select>
                    </div>

                    {/* Image Include */}
                    <div className="col-md-12">
                      <div className="form-check mt-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="image_include"
                          name="image_include"
                          checked={formData.image_include}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="image_include"
                        >
                          Include Image
                        </label>
                      </div>
                    </div>

                    {/* JSON Editors */}
                    {[
                      "header_mapping",
                      "parameter_mapping",
                      "request_mapping",
                      "response_mapping",
                    ].map((key) => (
                      <div className="col-md-6" key={key}>
                        <label>
                          {key
                            .replace("_", " ")
                            .replace(/\b\w/g, (l) => l.toUpperCase())}
                        </label>
                        <div className="json-editor-wrapper">
                          <JsonEditor
                            data={formData[key]}
                            setData={(newData) =>
                              handleJsonChange(key, newData)
                            }
                            theme={githubLightTheme}
                            rootName=""
                            indentLevel={2}
                          />
                        </div>
                      </div>
                    ))}

                    {/* Price Ranges */}
                    <div>
                      <label className="mb-2">
                        <strong>Details</strong>
                      </label>
                      {errors.priceRanges && (
                        <div className="text-danger">{errors.priceRanges}</div>
                      )}
                      {priceRanges.map((range, index) => (
                        <div className="mb-3 card p-3 shadow-sm" key={index}>
                          <div className="row g-2">
                            {/* Area Min */}
                            <div className="col-md-2">
                              <label className="mb-1">Area Minimum<span class= "text-danger">*</span></label>
                              <input
                                type="number"
                                name="area_min"
                                value={range.area_min}
                                onChange={(e) => handleRangeChange(index, e)}
                                placeholder="Min hectare"
                              />
                              {errors[`area_min_${index}`] && (
                                <div className="text-danger">
                                  {errors[`area_min_${index}`]}
                                </div>
                              )}
                            </div>

                            {/* Area Max */}
                            <div className="col-md-2">
                              <label className="mb-1">Area Maximum</label>
                              <input
                                type="number"
                                name="area_max"
                                value={range.area_max}
                                onChange={(e) => handleRangeChange(index, e)}
                                placeholder="Max hectare"
                              />
                                  {errors[`area_max_${index}`] && (
                                <div className="text-danger">
                                  {errors[`area_max_${index}`]}
                                </div>
                              )}
                            </div>

                            {/* Price Type */}
                            <div className="col-md-2">
                              <label className="mb-1">Price Type</label>
                              <select
                                name="price_type"
                                value={range.price_type || "Tiered"}
                                onChange={(e) => handleRangeChange(index, e)}
                              >
                                <option value="Tiered">Tiered</option>
                                <option value="Fixed">Fixed</option>
                              </select>
                            </div>

                            {/* Price */}
                            <div className="col-md-3">
                              <label className="mb-1">
                                {range.price_type === "Fixed"
                                  ? "Price"
                                  : "Price per Hectare"}
                              </label>
                              <input
                                type="number"
                                name="price_per_ha"
                                value={range.price_per_ha}
                                onChange={(e) => handleRangeChange(index, e)}
                                placeholder={
                                  range.price_type === "Fixed"
                                    ? "Price"
                                    : "Price per hectare"
                                }
                              />
                              {errors[`price_per_ha_${index}`] && (
                                <div className="text-danger">
                                  {errors[`price_per_ha_${index}`]}
                                </div>
                              )}
                            </div>

                            {/* Platform Fee */}
                            <div className="col-md-3">
                              <label className="mb-1">
                                {range.price_type === "Fixed"
                                  ? "Platform Fee"
                                  : "Platform Fee per Hectare"}
                                  <span class= "text-danger">*</span>
                              </label>
                              <input
                                type="number"
                                name="platform_fee_per_ha"
                                value={range.platform_fee_per_ha || ""}
                                onChange={(e) => handleRangeChange(index, e)}
                                placeholder={
                                  range.price_type === "Fixed"
                                    ? "Platform Fee"
                                    : "Platform Fee per hectare"
                                }
                              />
                            </div>
                          </div>

                          {/* Row-wise is_image toggle */}
                          <div className="col-md-12 d-flex align-items-center mt-2">
                            <input
                              type="checkbox"
                              name="is_image"
                              checked={range.is_image}
                              onChange={(e) => handleRangeChange(index, e)}
                            />
                            <label className="ms-2">Is Image</label>
                          </div>

                          {/* Image fields if is_image true */}
                          {range.is_image && (
                            <div className="row g-2 mt-2">
                              <div className="col-md-4">
                                <label className="mb-1">
                                  Image Price per Hectare
                                  <span class= "text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  name="image_price_per_ha"
                                  value={range.image_price_per_ha || ""}
                                  onChange={(e) => handleRangeChange(index, e)}
                                  placeholder="Image Price per hectare"
                                />
                                {errors[`image_price_per_ha_${index}`] && (
                                  <div className="text-danger">
                                    {errors[`image_price_per_ha_${index}`]}
                                  </div>
                                )}
                              </div>

                              <div className="col-md-4">
                                <label className="mb-1">
                                  Image Minimum Area
                                </label>
                                <input
                                  type="number"
                                  name="image_min_ha"
                                  value={range.image_min_ha || null}
                                  onChange={(e) => handleRangeChange(index, e)}
                                  placeholder="Image Min Hectare"
                                />
                                {errors[`image_min_ha_${index}`] && (
                                  <div className="text-danger">
                                    {errors[`image_min_ha_${index}`]}
                                  </div>
                                )}
                              </div>

                              <div className="col-md-4">
                                <label className="mb-1">
                                  Image Fixed Price
                                </label>
                                <input
                                  type="number"
                                  name="image_fix_price"
                                  value={range.image_fix_price || ""}
                                  onChange={(e) => handleRangeChange(index, e)}
                                  placeholder="Image Fixed Price"
                                />
                                {errors[`image_fix_price_${index}`] && (
                                  <div className="text-danger">
                                    {errors[`image_fix_price_${index}`]}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          {/* Remove button */}
                          {priceRanges.length > 1 && (
                            <div
                              type="button"
                              className="text-danger mt-2 w-100 d-flex justify-content-end"
                              onClick={() => removeRange(index)}
                            >
                              Remove
                            </div>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addNewRange}
                        className="btn btn-info text-light"
                      >
                        + Add fields
                      </button>
                    </div>

                    {/* Submit Buttons */}
                    <div className="col-md-12 d-flex justify-content-end gap-2">
                      <NavLink
                        to={"/vendor-services"}
                        type="button"
                        className="transparent_btn"
                      >
                        Cancel
                      </NavLink>
                      <button
                        type="submit"
                        className="blue_btn"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Updating..." : "Update Vendor Service"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default EditVendorService;
